const FILTERS = {
    'ALL': 'ALL',
    'CIUDADES': 'CIUDADES',
    'DESARROLLOS': 'DESARROLLOS'
}

export default FILTERS;